/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ShopOrderItem,
} from '../models/index';
import {
    ShopOrderItemFromJSON,
    ShopOrderItemToJSON,
} from '../models/index';

export interface ShopOrderItemCreateRequest {
    data?: ShopOrderItem;
}

export interface ShopOrderItemDeleteByIdRequest {
    id: string;
}

export interface ShopOrderItemFindRequest {
    filter?: string;
}

export interface ShopOrderItemFindByIdRequest {
    id: string;
    filter?: string;
}

/**
 * 
 */
export class ShopOrderItemApi extends runtime.BaseAPI {

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shopOrderItemCreateRaw(requestParameters: ShopOrderItemCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopOrderItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopOrderItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShopOrderItemToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopOrderItemFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shopOrderItemCreate(requestParameters: ShopOrderItemCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopOrderItem> {
        const response = await this.shopOrderItemCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shopOrderItemDeleteByIdRaw(requestParameters: ShopOrderItemDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopOrderItemDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopOrderItems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shopOrderItemDeleteById(requestParameters: ShopOrderItemDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shopOrderItemDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shopOrderItemFindRaw(requestParameters: ShopOrderItemFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShopOrderItem>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopOrderItems`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShopOrderItemFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shopOrderItemFind(requestParameters: ShopOrderItemFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShopOrderItem>> {
        const response = await this.shopOrderItemFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shopOrderItemFindByIdRaw(requestParameters: ShopOrderItemFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopOrderItem>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopOrderItemFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopOrderItems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopOrderItemFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shopOrderItemFindById(requestParameters: ShopOrderItemFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopOrderItem> {
        const response = await this.shopOrderItemFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
